import UploadOutlined from '@ant-design/icons/lib/icons/UploadOutlined';
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  Steps,
  Tabs,
  Typography,
} from 'antd';
import '../ConfigureMentee/index.style.less';
import '../index.style.less';
import './index.style.less';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AppRowContainer } from '../../../../@crema';
import jwtAxios from '../../../../@crema/services/auth/jwt-auth/jwt-api';
import {
  useAuthMethod,
  useAuthUser,
} from '../../../../@crema/utility/AuthHooks';
import { sendFile } from '../PersonalInfo';
import PhoneInput from '../PersonalInfo/PhoneInput';
import SelectProfile from '../SelectProfile';
import moment from 'moment';
import IntlMessages from '../../../../@crema/utility/IntlMessages';
import MenteeTermSection from '../MenteeTerm/MenteeTermSection';
import { putDataApi } from '../../../../@crema/utility/APIHooks';
import _, { first, last } from 'lodash';

const { Step } = Steps;
const { Text } = Typography;

const OnboardingSignUp = () => {
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();

  const [defaultTargetRole, setDefaultTargetRole] = useState(null);
  const [targetRole, setTargetRole] = useState(null);
  const [isDisabled, setIsDisable] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [content, setContent] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthUser();
  const { getUserProfile, signUpUser } = useAuthMethod();
  const [userImage, setUserImage] = useState('/assets/images/placeholder.jpg');
  const isAuthenticated = !!user;

  useEffect(() => {
    if (queryParams) {
      const type = queryParams.get('type');
      if (type) {
        setDefaultTargetRole(type);
        setTargetRole(type);
        setCurrentStep(1);
      }
    }
  }, [queryParams]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: async (acceptedFiles) => {
      setUserImage(URL.createObjectURL(acceptedFiles[0]));
      const { data } = await jwtAxios.get('/file/prepare-upload/non', {
        params: {
          contentType: acceptedFiles[0].type,
          fileName: acceptedFiles[0].name,
          type: 'avatar',
        },
      });

      const url = await sendFile(data.url, acceptedFiles[0]);
      setUserImage(url);
    },
  });

  const getContent = () => {
    jwtAxios
      .get('content')
      .then((res) => {
        setContent(res.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);

  const [form] = Form.useForm();

  const onNext = async () => {
    const nextStep = currentStep + 1;
    const phone = form?.getFieldValue('phone');
    if (currentStep === 1 && phone) {
      const isValid = isValidPhoneNumber(phone);
      if (!isValid) {
        form?.setFields([
          {
            name: 'phone',
            errors: ['Invalid contact number'],
          },
        ]);
        document.getElementById('phone').scrollIntoView();
        return;
      }
    }

    setCurrentStep(nextStep);
    getDisabledNext(nextStep);
  };

  const getDisabledNext = () => {
    setIsDisable(false);
  };

  const onSubmit = async (values) => {
    const isValid = isValidPhoneNumber(values.phone);
    if (!isValid) {
      form.setFields([
        {
          name: ['phone'],
          errors: ['Invalid Contact Number'],
        },
      ]);
      form.scrollToField(['phone'], {
        block: 'center',
        behavior: 'smooth',
      });
      return;
    }

    const body = {
      ...values,
      dob: values.dob.format('YYYY-MM-DD'),
      avatar: userImage,
      userType: targetRole === 'mentor' ? 'Mentor' : 'Mentee',
    };
    setIsLoading(true);

    if (isAuthenticated) {
      await putDataApi('/auth/onboarding', body, {
        fetchSuccess: () => {
          window.location.href = '/assessment';
          setIsLoading(false);
        },
      });
      setIsLoading(false);
      return;
    }

    signUpUser(
      body,
      () => {
        setIsLoading(false);
        navigate(`/auth/verify-email`, { state: { email: values.email } });
      },
      ({ errorMessage }) => {
        setIsLoading(false);
        message.error(errorMessage);
      },
    );
  };

  const isMentee = targetRole === 'mentee';

  const TITLES = [
    'WELCOME ONBOARD',
    isMentee ? 'MENTEE ACCOUNT REGISTRATION' : 'ACCOUNT SETUP',
  ];
  const DESCRIPTIONS = [
    `Join Mentoring SG as a?`,
    isMentee
      ? 'Please provide information to create a new Mentee account'
      : 'To get you started, please update your profile.',
  ];

  const onBackClick = () => {
    form.resetFields();
    const prevStep = currentStep - 1;
    if (prevStep >= 0) {
      setCurrentStep(prevStep);
      return;
    }

    navigate(-1);
  };

  const onFinishFailed = (errorInfo) => {
    if (errorInfo?.errorFields?.length > 0) {
      const field = first(errorInfo.errorFields);
      if (field) {
        form.scrollToField(field.name, {
          block: 'center',
          behavior: 'smooth',
        });

        if (field.name[0] === 'phone') {
          setTimeout(() => {
            document.getElementById('phone').scrollIntoView();
          }, 100);
        }
      }
    }
  };

  return (
    <div className='user-profile-container p-16'>
      <Form
        form={form}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        layout='vertical'
        initialValues={{
          firstName: user?.profile?.firstName,
          lastName: user?.profile?.lastName,
        }}
        id='form'>
        <h3 className='user-profile-form-title title-primary'>
          {TITLES[currentStep]}
        </h3>
        <p className='user-profile-form-description'>
          {DESCRIPTIONS[currentStep]}
        </p>

        <Tabs
          defaultActiveKey={currentStep}
          activeKey={currentStep.toString()}
          renderTabBar={() => null}>
          <Tabs.TabPane key={0} className='custom-checkbox-group'>
            <SelectProfile
              defaultValue={defaultTargetRole}
              onChange={setTargetRole}
            />
          </Tabs.TabPane>

          <Tabs.TabPane key={1}>
            <Row>
              <Col xs={24} md={{ span: 16, offset: 4 }}>
                <Row gutter={32} style={{ paddingBottom: 80 }}>
                  <Col xs={{ offset: 0, span: 24 }} md={{ span: 6 }}>
                    <Form.Item className='info-upload'>
                      <div
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}>
                        <div
                          style={{
                            width: '100%',
                            justifyContent: 'center',
                            position: 'relative',
                          }}>
                          <Avatar
                            className='info-upload-avatar'
                            size={164}
                            style={{ marginTop: 68 }}
                            src={userImage}
                          />
                        </div>
                        <div
                          className='info-upload-content mt-8'
                          style={{ marginTop: 20 }}>
                          <div className='info-upload-btn-group'>
                            <div {...getRootProps({ className: 'dropzone' })}>
                              <input {...getInputProps()} />
                              <label htmlFor='icon-button-file'>
                                <Button
                                  danger
                                  style={{ minHeight: 40 }}
                                  size='large'
                                  icon={<UploadOutlined />}>
                                  UPLOAD PHOTO
                                </Button>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col xs={{ offset: 0, span: 24 }} md={{ span: 18 }}>
                    <AppRowContainer gutter={16}>
                      {!isAuthenticated && (
                        <>
                          <Col md={24} xs={24}>
                            <h4 style={{ fontSize: 24 }}>
                              Account Information
                            </h4>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              name='email'
                              label={'Email Address'}
                              requiredMark={'*'}
                              rules={[
                                {
                                  required: true,
                                  message: 'Enter Email Address.',
                                },
                              ]}>
                              <Input
                                type='text'
                                placeholder='Enter Email Address'
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              name='password'
                              label={'Password'}
                              requiredMark={'*'}
                              rules={[
                                {
                                  required: true,
                                  message: 'Enter Password.',
                                },
                              ]}>
                              <Input.Password
                                type='text'
                                placeholder='Enter Password'
                              />
                            </Form.Item>
                          </Col>
                        </>
                      )}
                      <Col md={24} xs={24}>
                        <h4 style={{ fontSize: 24 }}>Profile Information</h4>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item
                          name='firstName'
                          label={'First Name'}
                          requiredMark={'*'}
                          rules={[
                            {
                              required: true,
                              message: 'Enter First Name',
                            },
                          ]}>
                          <Input type='text' placeholder='Enter First Name' />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item
                          name='lastName'
                          label={'Surname'}
                          requiredMark={'*'}
                          rules={[
                            {
                              required: true,
                              message: 'Enter Surname',
                            },
                          ]}>
                          <Input type='text' placeholder='Enter Surname' />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                        <Form.Item
                          name='dob'
                          label={'Date of Birth'}
                          className='form-field form-item-w-100'
                          requiredMark='*'
                          rules={[
                            {
                              required: true,
                              message: 'Select Date of Birth',
                            },
                          ]}>
                          <DatePicker
                            placeholder='Select Date of Birth'
                            allowClear
                            disabledDate={(current) => {
                              let customDate = moment().format('YYYY-MM-DD');
                              return (
                                current &&
                                current > moment(customDate, 'YYYY-MM-DD')
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item
                          name='gender'
                          label={'Gender'}
                          rules={[
                            { required: true, message: 'Select Gender!' },
                          ]}>
                          <Select placeholder='Gender'>
                            {['Male', 'Female'].map((e) => (
                              <Select.Option value={e} key={e}>
                                {e}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <PhoneInput
                          id='phone'
                          requiredMark='Optional'
                          name={['phone']}
                          label={'Contact Number'}
                          form={form}
                          rules={[
                            {
                              required: true,
                              message: 'Please input your Contact Number!',
                            },
                          ]}
                        />
                      </Col>
                      <Col md={12} xs={24} />

                      <Col md={12} xs={24}>
                        <Form.Item
                          name='countryId'
                          label={'Country of Residences'}
                          requiredMark={'*'}
                          rules={[
                            {
                              required: true,
                              message: 'Enter Country of Residences',
                            },
                          ]}>
                          <Select
                            placeholder='Country of Residences'
                            showSearch
                            optionFilterProp='children'
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }>
                            {content.countries?.map((e) => (
                              <Select.Option value={e.id} key={e.id}>
                                {e.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item
                          name='last4NRIC'
                          label={'Last 4 characters of NRIC'}
                          requiredMark={'*'}
                          rules={[
                            {
                              required: true,
                              message: 'Enter Last 4 characters of NRIC',
                            },
                          ]}>
                          <Input.Password
                            type='text'
                            maxLength={4}
                            placeholder='Enter Last 4 characters of NRIC'
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name='company'
                          label={isMentee ? 'School Name' : 'Company Name'}
                          requiredMark={'*'}
                          rules={[
                            {
                              required: true,
                              message: isMentee
                                ? 'Enter School Name'
                                : 'Enter Company Name',
                            },
                          ]}>
                          <Input
                            type='text'
                            maxLength={255}
                            placeholder={
                              isMentee ? 'School Name' : 'Company Name'
                            }
                          />
                        </Form.Item>
                      </Col>

                      {isMentee ? (
                        <Col xs={24} md={12}>
                          <Form.Item
                            name='program'
                            label={'Faculty / Course'}
                            requiredMark={'*'}
                            rules={[
                              {
                                required: true,
                                message: 'Enter Faculty / Course',
                              },
                            ]}>
                            <Input
                              type='text'
                              maxLength={255}
                              placeholder='e.g Finance, Engineering'
                            />
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col xs={24} md={12}>
                          <Form.Item
                            name='jobRoleId'
                            label={'Job Role'}
                            requiredMark={'*'}
                            rules={[
                              {
                                required: true,
                                message: 'Enter Job Role',
                              },
                            ]}>
                            <Select
                              placeholder='Select Job Role'
                              showSearch
                              optionFilterProp='children'
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }>
                              {content.jobRoles?.map((e) => (
                                <Select.Option value={e.id} key={e.key}>
                                  {e.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}

                      <Col xs={24} md={12}>
                        <Form.Item name='webLink' label={'Web Link'} rules={[]}>
                          <Input
                            type='text'
                            maxLength={255}
                            placeholder='https://'
                          />
                        </Form.Item>
                      </Col>

                      <Col md={24} xs={24}>
                        <h4 style={{ fontSize: 24 }}>Terms and Conditions</h4>
                      </Col>

                      <Col xs={24} md={24}>
                        <Form.Item
                          className='form-field signup-checkbox'
                          name='agreeTerms'
                          rules={[
                            {
                              validator: (_, value) =>
                                value
                                  ? Promise.resolve()
                                  : Promise.reject(
                                      new Error(
                                        'Please accept the terms and conditions',
                                      ),
                                    ),
                            },
                          ]}
                          valuePropName='checked'>
                          <Checkbox>
                            I agree to the{' '}
                            <Link
                              to='/terms-and-conditions'
                              target={'_blank'}
                              className='text-underline'>
                              terms and conditions
                            </Link>
                          </Checkbox>
                        </Form.Item>
                      </Col>

                      <Col md={24} xs={24}>
                        <h4 style={{ fontSize: 24 }}>
                          Approval for Use of Personal Information
                        </h4>
                      </Col>

                      <Col xs={24} md={24}>
                        <Form.Item
                          className='form-field signup-checkbox'
                          name='agreePI'
                          rules={[
                            {
                              validator: (_, value) =>
                                value
                                  ? Promise.resolve()
                                  : Promise.reject(
                                      new Error(
                                        'Please agree to Approval for Use of Personal Information',
                                      ),
                                    ),
                            },
                          ]}
                          valuePropName='checked'>
                          <Checkbox>
                            I agree for Mentoring SG (“MSG”) and the National
                            Youth Council (“NYC”) to send me marketing and
                            communication materials including upcoming youth
                            programmes and events via email. I agree that the
                            personal information which I have provided will be
                            used by MSG and NYC to send me such marketing and
                            communication materials and to improve its planning
                            and delivery of youth programmes and events and will
                            not be disclosed to any other agencies or
                            individuals. I understand that I can unsubscribe at
                            any time.
                          </Checkbox>
                        </Form.Item>
                      </Col>

                      {isMentee && (
                        <Col md={24} xs={24}>
                          <h4 style={{ fontSize: 24 }}>Welcome Video</h4>
                        </Col>
                      )}

                      {isMentee && (
                        <Col xs={24} md={24}>
                          <div className='video-responsive'>
                            <iframe
                              id='youtube-player2'
                              width='853'
                              height='480'
                              src={
                                'https://www.youtube.com/embed/QJXf2Byk1tQ?enablejsapi=1&rel=0;controls=0'
                              }
                              frameBorder='0'
                              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                              allowFullScreen
                              title='Embedded youtube'
                            />
                          </div>
                        </Col>
                      )}
                    </AppRowContainer>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>
        <Space className='pb-5' size={100} />
        <Col xs={24} md={24} className='user-profile-footer'>
          <div className='container user-profile-footer_content'>
            {(currentStep >= 0 && !isAuthenticated) ||
            (currentStep > 0 && isAuthenticated) ? (
              <Button danger onClick={onBackClick}>
                <LeftOutlined />
                BACK
              </Button>
            ) : (
              <div style={{ width: 90 }} />
            )}

            <Space>
              {currentStep < 1 && (
                <Button
                  form='form'
                  disabled={isDisabled || !targetRole}
                  danger
                  onClick={onNext}
                  loading={isLoading}>
                  {'NEXT'}
                  <RightOutlined />
                </Button>
              )}
              {currentStep === 1 && (
                <Button
                  type='primary'
                  htmlType='submit'
                  disabled={false}
                  loading={isLoading}>
                  SUBMIT
                </Button>
              )}
            </Space>
          </div>
        </Col>
      </Form>
    </div>
  );
};

export default OnboardingSignUp;
